const question3 = {
    'question': 'Czy psycholog diagnozuje?',
    'answer': 'Tak, psychologowie diagnozują. Diagnoza psychologiczna to proces, w ramach którego psycholog określa, czy dana osoba spełnia kryteria diagnostyczne określone w klasyfikacji zaburzeń psychicznych. Diagnoza ta jest podstawą do podjęcia odpowiedniego leczenia lub terapii.',
}

export default question3;